import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import { MeterRemoveComponent } from '@shared/modals/meter/meter-remove/meter-remove.component';

export const meterRemoveModalConfig: ModalConfig = {
  component: MeterRemoveComponent,
  title: 'meter.remove.title',
  actions: [
    {
      type: 'primary',
      label: 'action.remove',
      method: 'submit'
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true
    },
  ],
}
